import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import type { EditAsideSecondaryEducationType } from '@nodeTypeConfig/configTypes';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { any } from 'prop-types';
import type React from 'react';

import { patchNodeAction } from '@store/actions/documentActions';
import { set, sortBy } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import type { IApiResouce } from '@generalTypes/sriTypes';

import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';
import { selectSecondaryEducationTypes } from './asideSecondaryEducationSelectors';

const AsideSecondaryEducationType: React.FC<{
  config: EditAsideSecondaryEducationType;
  readonly: boolean;
}> = ({ config, readonly }) => {
  /**
   * very similar component to AsideSimpleDropDown.tsx
   */
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const secundaryEducationTypes = useSelector(selectSecondaryEducationTypes);

  const options = sortBy(Object.values(secundaryEducationTypes), ['name']);

  const currentValue = useInitialValue(config.property);

  const defaultValue = secundaryEducationTypes[currentValue];

  const onChange = (selection: IApiResouce) => {
    dispatch(
      patchNodeAction(
        getResourceKey(editHref),
        set({}, config.property, selection.$$meta.permalink),
      ),
    );
  };

  return (
    <div>
      <label className="control-label">{config.label}</label>
      {!options.length ? (
        <div className="form-group shimmer narrowLine" />
      ) : (
        <KovResourcePicker
          localData={options}
          display="name"
          defaultValue={defaultValue}
          clearable={config.options.clearable}
          disabled={readonly}
          disableSearch={true}
          style={{ option: (provided) => ({ ...provided, cursor: 'pointer' }) }}
          onChange={onChange}
        />
      )}
    </div>
  );
};

AsideSecondaryEducationType.displayName = 'AsideSecondaryEducationType';

AsideSecondaryEducationType.propTypes = {
  config: any,
  readonly: any,
};

export default AsideSecondaryEducationType;
